(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nho-in-use"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nho-slideshow')) {
  customElements.define('nho-slideshow', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = this.querySelectorAll('[data-gallery-slide]');
      this.controls = this.querySelector('[data-gallery-controls]');
      if (!this.track || !this.controls || this.slides.length < 2) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previous = this.querySelector('[data-gallery-prev]');
      this.next = this.querySelector('[data-gallery-next]');
      this.currentLabel = this.querySelector('[data-gallery-current]');
      this.totalLabel = this.querySelector('[data-gallery-total]');
      this.previous.addEventListener('click', () => this.go(-1), options);
      this.next.addEventListener('click', () => this.go(1), options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.track.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      }, { passive: true, signal: this.controller.signal });
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.controls.hidden = false;
      this.update();
    }
    metrics() {
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = this.slides[0].getBoundingClientRect().width + gap;
      const perPage = Math.max(1, Math.round(this.track.clientWidth / step));
      const pageWidth = step * perPage;
      const pages = Math.ceil(this.slides.length / perPage);
      const page = Math.min(pages - 1, Math.max(0, Math.round(this.track.scrollLeft / pageWidth)));
      return { pageWidth, pages, page };
    }
    update() {
      const { page, pages } = this.metrics();
      this.currentLabel.textContent = String(page + 1);
      this.totalLabel.textContent = String(pages);
      this.previous.disabled = page === 0;
      this.next.disabled = page === pages - 1;
    }
    go(direction) {
      const { page, pages, pageWidth } = this.metrics();
      const nextPage = Math.min(pages - 1, Math.max(0, page + direction));
      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.track.scrollTo({ left: nextPage * pageWidth, behavior });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
